import React from 'react'
import GamesList from '../components/GamesList'

const Home = () => {
  return (
    <div>
        <GamesList/>
    </div>
  )
}

export default Home